export default __webpack_public_path__ + "static/media/healthtech-guild-background.e288ae3b.png";